export const ROUTES = {
    HOME:         '/',
    NOT_FOUND:    '/404',
    NO_ACCOUNT:   '/no-account',
    LOGIN:        '/login',
    LOGOUT:       '/logout',
    ADMIN:        {
        ROOT:     '/admin',
        CHILDREN: {
            DECISION_ENGINE:   {
                ROOT:     '/decision-engine',
                CHILDREN: {
                    QUESTIONS:   '/question-intake',
                    OBJECTIVES:  {
                        ROOT:     '/objectives',
                        CHILDREN: {
                            SECTION: '/:section/:entityId?',
                        }
                    },
                    ACTIVITIES:  {
                        ROOT:     '/activities',
                        CHILDREN: {
                            SECTION: '/:section/:entityId?',
                        }
                    },
                    CATEGORIES:  '/categories',
                    ASSUMPTIONS: '/assumptions',
                    RESOURCES:   {
                        ROOT:     '/resources',
                        CHILDREN: {
                            FEES:       {
                                ROOT:     '/professional-fees',
                                CHILDREN: {
                                    SECTION: '/:section/:entityId?'
                                },
                            },
                            HIRE_TYPES: {
                                ROOT:     '/hire-types',
                                CHILDREN: {
                                    SECTION: '/:section/:entityId?'
                                },
                            },
                            BUSINESS_FUNCTIONS: {
                                ROOT:     '/business-functions',
                                CHILDREN: {
                                    SECTION: '/:section/:entityId?'
                                },
                            }
                        }
                    },
                }
            },
            SYSTEM_ACCOUNTING: {
                ROOT:     '/accounts',
                CHILDREN: {
                    ORGANIZATIONS: '/organizations',
                    USERS:         '/users',
                }
            }
        },
    },
    DASH: '/dash',
    DORA_AI: '/ai-assistant',
    DASHBOARD:    '/dashboard',
    PROJECTS:     '/projects',
    PROJECT:      {
        ROOT:     '/project/:projectId',
        CHILDREN: {
            MANAGE:            {
                ROOT:     '/manage',
                CHILDREN: {
                    SETTINGS: '/settings/:section?',
                    ACTIVITY: '/activity',
                }
            },
            DASHBOARD: '/dashboard',
            SURVEYS:           {
                ROOT:     '/surveys',
                CHILDREN: {
                    CATEGORY: '/category/:categoryId',
                    INQUIRY:  '/inquiry',
                }
            },
            ASSUMPTIONS:       '/assumptions',
            DASH:       '/dash',
            PLANNING:          '/planning/:section?',
            OBJECTIVES:        {
                ROOT:     '/objectives',
                CHILDREN: {
                    SELECT_ANY:         '/select/all',
                    SELECT_BY_CATEGORY: '/select/category/:categoryId',
                    REVIEW:             '/review/:section?',
                    ROADMAP:            '/roadmap',
                }
            },
            RESOURCE_PLANNING: {
                ROOT:     '/resource-planning',
                CHILDREN: {
                    REPORTS:                 {
                        ROOT:     '/reports',
                        CHILDREN: {
                            SUMMARY_VISUALIZATION: '/budget/summary'
                        }
                    },
                    BUDGET_SUMMARY:          '/reports/budget/summary',
                    BUDGET_BY_CATEGORY_DATA: '/budget/by-category',
                    BUDGET_HIRING_DATA:      '/budget/hiring',
                    HIRING_MANAGER:          '/hiring',
                }
            },
            MAP:               {
                ROOT:     '/map',
                CHILDREN: {
                    TYPES: {
                        ROOT:     '/types',
                        CHILDREN: {
                            GRID:  '/grid',
                            GANTT: '/gantt',
                        }
                    }
                }
            },
            USERS:             '/users/:accountId',
            TOOLS:             {
                ROOT:     '/tools',
                CHILDREN: {
                    SEARCH: {
                        ROOT:     '/search',
                        CHILDREN: {
                            ACTIVITY_EDITABLE_SEARCH: '/activities',
                        }
                    }
                }
            },
        },
    },
    USERS:        {
        ROOT:     '/org/:organizationId/user/:accountId',
        CHILDREN: {
            PROFILE: '/profile',
        },
    },
    CURRENT_USER: {
        ROOT:     '/account',
        CHILDREN: {
            DETAILS: '/:section',
        },
    },
};
